/* Allbag: quiz doboru rozmiaru torby papierowej (sekcja ab-size-quiz) */
(function (root) {
  'use strict';
  var TIERS = { eco: ['plaski', 'klockowa'], uni: ['skrecany'], prem: ['premium', 'sznurkowy', 'laminowana'], any: null };
  var QTY = { one: [[1, 1, 1]], few: [[1.9, 1, 1], [1, 2.3, 1], [1, 1, 2.2]], many: [[2.4, 1.6, 1], [1.6, 2.4, 1], [1.2, 1.2, 3]] };
  var TYPE_W = { skrecany: 0.8, plaski: 0.85, klockowa: 1.0, premium: 1.0, sznurkowy: 1.05, laminowana: 1.1, faldowa: 1.1, inne: 1.1 };

  function vol(sz) { return sz.w * sz.d * sz.h; }
  function fitsSize(sz, req) {
    var a = sz.w >= req.w && sz.d >= req.d && sz.h >= req.h;
    var b = sz.w >= req.h && sz.d >= req.d && sz.h >= req.w;
    return a || b;
  }
  function score(sz) {
    var s = vol(sz) * (1 - 0.03 * Math.min(sz.n, 10));
    if (sz.stock > 50000) s *= 0.9; else if (sz.stock < 1000) s *= 1.3;
    s *= TYPE_W[dominantType(sz)] || 1;
    s *= 1 + Math.min(sz.minPrice || 0, 10) / 3;
    return s;
  }
  function shortfall(sz, req) {
    var a = Math.max(req.w / sz.w, req.d / sz.d, req.h / sz.h), b = Math.max(req.h / sz.w, req.d / sz.d, req.w / sz.h);
    return Math.min(a, b);
  }
  function typesOf(sz) { return Object.keys(sz.types || {}); }
  function hasTier(sz, tier) { var list = TIERS[tier]; if (!list) return true; return typesOf(sz).some(function (t) { return list.indexOf(t) >= 0; }); }
  function usable(sz) { return sz.stock > 0 && sz.mfDims && sz.mfDims.length; }

  function recommend(sizes, uc, qty, tier) {
    var mults = QTY[qty] || QTY.one, relaxed = false;
    function search(tierKey) {
      var found = null;
      mults.forEach(function (m) {
        var req = { w: uc.w * m[0], d: uc.d * m[1], h: uc.h * m[2] };
        sizes.forEach(function (sz) {
          if (!usable(sz) || !fitsSize(sz, req) || !hasTier(sz, tierKey)) return;
          var sc = score(sz);
          if (!found || sc < found.sc) found = { sz: sz, sc: sc, req: req };
        });
      });
      return found;
    }
    var best = search(tier), bestAny = tier === 'any' ? best : search('any');
    if (!best && bestAny) { best = bestAny; relaxed = true; }
    else if (best && bestAny && best.sz !== bestAny.sz && vol(best.sz) > 3 * vol(bestAny.sz)) { best = bestAny; relaxed = true; }
    if (!best) {
      var fb = null;
      mults.forEach(function (m) {
        var req = { w: uc.w * m[0], d: uc.d * m[1], h: uc.h * m[2] };
        sizes.forEach(function (sz) { if (!usable(sz)) return; var sf = shortfall(sz, req) * (1 + score(sz) / 1e9); if (!fb || sf < fb.sf) fb = { sz: sz, sc: score(sz), req: null, sf: sf }; });
      });
      best = fb; relaxed = true; best.tooBig = true;
    }
    var alt = null, v0 = vol(best.sz), tierForAlt = relaxed ? 'any' : tier;
    sizes.forEach(function (sz) {
      if (sz === best.sz || !usable(sz)) return;
      if (vol(sz) < v0 * 1.15) return;
      if (best.req && !fitsSize(sz, best.req)) return;
      if (!hasTier(sz, tierForAlt)) return;
      var sc = score(sz);
      if (!alt || sc < alt.sc) alt = { sz: sz, sc: sc };
    });
    var sib = sizes.filter(function (sz) {
      return sz !== best.sz && usable(sz) && Math.abs(sz.w - best.sz.w) <= 10 && Math.abs(sz.d - best.sz.d) <= 10 && Math.abs(sz.h - best.sz.h) <= 20;
    });
    return { size: best.sz, alt: alt ? alt.sz : null, siblings: sib, relaxed: relaxed, tooBig: !!best.tooBig, req: best.req };
  }

  function filterParams(sz) {
    var ws = {}, ds = {}, hs = {}, q = [];
    (sz.mfDims || []).forEach(function (s) { var p = s.split('|'); ws[p[0]] = 1; ds[p[1]] = 1; hs[p[2]] = 1; });
    Object.keys(ws).forEach(function (v) { q.push('filter.p.m.filters.szerokosc_=' + encodeURIComponent(v)); });
    Object.keys(ds).forEach(function (v) { q.push('filter.p.m.custom.glebokosc=' + encodeURIComponent(v)); });
    Object.keys(hs).forEach(function (v) { q.push('filter.p.m.filtry.wysokosc=' + encodeURIComponent(v)); });
    return q.join('&');
  }
  function dims(sz) { return sz.w + '\u00a0×\u00a0' + sz.d + '\u00a0×\u00a0' + sz.h + '\u00a0mm'; }
  function typeList(sz, label) { return typesOf(sz).map(function (t) { return label ? label(t) : t; }).join(', '); }
  function dominantType(sz) { var best = null; typesOf(sz).forEach(function (t) { if (!best || sz.types[t] > sz.types[best]) best = t; }); return best; }

  var ABQ = { recommend: recommend, filterParams: filterParams, dims: dims, typeList: typeList, dominantType: dominantType };
  if (typeof module !== 'undefined' && module.exports) { module.exports = ABQ; return; }
  root.ABQ = ABQ;

  /* ---------- rysunek torby ---------- */
  function bagGeom(w, d, h, W, H, pad) {
    var dx = d * 0.55, dy = d * 0.32, hh = Math.min(h * 0.16, 34);
    var k = Math.min((W - pad * 2) / (w + dx), (H - pad * 2) / (h + dy + hh));
    var bw = w * k, bh = h * k, sx = dx * k, sy = dy * k, hk = hh * k;
    var x0 = (W - (bw + sx)) / 2, yb = H - pad, y0 = yb - bh;
    return { x0: x0, y0: y0, bw: bw, bh: bh, sx: sx, sy: sy, hk: hk, yb: yb };
  }
  function r1(n) { return Math.round(n * 10) / 10; }
  function bagPaths(g) {
    var x0 = g.x0, y0 = g.y0, bw = g.bw, bh = g.bh, sx = g.sx, sy = g.sy, hk = g.hk;
    var h1 = x0 + bw * 0.3, h2 = x0 + bw * 0.7;
    return {
      back: 'M' + r1(h1 + sx) + ' ' + r1(y0 - sy) + ' C' + r1(h1 + sx) + ' ' + r1(y0 - sy - hk) + ' ' + r1(h2 + sx) + ' ' + r1(y0 - sy - hk) + ' ' + r1(h2 + sx) + ' ' + r1(y0 - sy),
      side: 'M' + r1(x0 + bw) + ' ' + r1(y0) + ' l' + r1(sx) + ' ' + r1(-sy) + ' v' + r1(bh) + ' l' + r1(-sx) + ' ' + r1(sy) + ' z',
      top: 'M' + r1(x0) + ' ' + r1(y0) + ' l' + r1(sx) + ' ' + r1(-sy) + ' h' + r1(bw),
      front: 'M' + r1(x0) + ' ' + r1(y0) + ' h' + r1(bw) + ' v' + r1(bh) + ' h' + r1(-bw) + ' z',
      handle: 'M' + r1(h1) + ' ' + r1(y0) + ' C' + r1(h1) + ' ' + r1(y0 - hk) + ' ' + r1(h2) + ' ' + r1(y0 - hk) + ' ' + r1(h2) + ' ' + r1(y0)
    };
  }
  function bagBody(g) {
    var p = bagPaths(g);
    return '<path class="abq-bag__handle" d="' + p.back + '"/><path class="abq-bag__side" d="' + p.side + '"/><path class="abq-bag__front" d="' + p.front + '"/><path class="abq-bag__top" d="' + p.top + '"/><path class="abq-bag__handle" d="' + p.handle + '"/>';
  }
  function bagStatic(sz) {
    var W = 260, H = 210, g = bagGeom(sz.w, sz.d, sz.h, W - 60, H - 56, 4);
    g.x0 += 12; g.y0 += 26; g.yb += 26;
    var s = '<svg class="abq__bag" viewBox="0 0 ' + W + ' ' + H + '" aria-hidden="true" focusable="false">' + bagBody(g);
    var yl = g.yb + 14, xr = g.x0 + g.bw + g.sx + 16;
    s += '<path class="abq-bag__dim" d="M' + r1(g.x0) + ' ' + r1(yl) + ' h' + r1(g.bw) + ' M' + r1(g.x0) + ' ' + r1(yl - 4) + ' v8 M' + r1(g.x0 + g.bw) + ' ' + r1(yl - 4) + ' v8"/>';
    s += '<text class="abq-bag__t" x="' + r1(g.x0 + g.bw / 2) + '" y="' + r1(yl + 15) + '" text-anchor="middle">' + sz.w + ' mm</text>';
    s += '<path class="abq-bag__dim" d="M' + r1(xr) + ' ' + r1(g.y0 - g.sy) + ' v' + r1(g.bh) + ' M' + r1(xr - 4) + ' ' + r1(g.y0 - g.sy) + ' h8 M' + r1(xr - 4) + ' ' + r1(g.y0 - g.sy + g.bh) + ' h8"/>';
    s += '<text class="abq-bag__t" x="' + r1(xr + 7) + '" y="' + r1(g.y0 - g.sy + g.bh / 2 + 4) + '">' + sz.h + '</text>';
    s += '<text class="abq-bag__t abq-bag__t--s" x="' + r1(g.x0 + g.bw + g.sx / 2 + 6) + '" y="' + r1(g.y0 - g.sy - 8) + '" text-anchor="middle">' + sz.d + '</text>';
    return s + '</svg>';
  }
  function initBanner(box) {
    if (!box || box.__abqAnim) return; box.__abqAnim = true;
    var W = 200, H = 150, SIZES = [[180, 80, 225], [240, 100, 320], [300, 170, 340], [400, 180, 390]];
    var reduce = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
    box.innerHTML = '<svg class="abq__anim-svg" viewBox="0 0 ' + W + ' ' + H + '" aria-hidden="true" focusable="false"><g data-bag></g><text class="abq-bag__t abq-bag__t--lbl" data-lbl x="' + (W / 2) + '" y="' + (H - 3) + '" text-anchor="middle"></text></svg>';
    var gEl = box.querySelector('[data-bag]'), lbl = box.querySelector('[data-lbl]');
    function draw(sz) { gEl.innerHTML = bagBody(bagGeom(sz[0], sz[1], sz[2], W, H - 26, 6)); }
    function label(sz) { return sz[0] + ' × ' + sz[1] + ' × ' + sz[2] + ' mm'; }
    if (reduce) { draw(SIZES[1]); lbl.textContent = label(SIZES[1]); return; }
    var HOLD = 1700, MORPH = 950, PER = HOLD + MORPH, n = SIZES.length, start = null, raf = null, running = false;
    function ease(p) { return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; }
    function frame(now) {
      if (!running) return;
      if (start === null) start = now;
      var t = (now - start) % (PER * n), i = Math.floor(t / PER), u = t - i * PER, a = SIZES[i], b = SIZES[(i + 1) % n];
      if (u < HOLD) { draw(a); lbl.textContent = label(a); lbl.style.opacity = 1; }
      else { var p = ease((u - HOLD) / MORPH); draw([a[0] + (b[0] - a[0]) * p, a[1] + (b[1] - a[1]) * p, a[2] + (b[2] - a[2]) * p]); var half = p < 0.5; lbl.textContent = label(half ? a : b); lbl.style.opacity = half ? 1 - p * 2 : (p - 0.5) * 2; }
      raf = root.requestAnimationFrame(frame);
    }
    function play() { if (running || document.hidden) return; running = true; start = null; raf = root.requestAnimationFrame(frame); }
    function stop() { running = false; if (raf) root.cancelAnimationFrame(raf); }
    draw(SIZES[1]); lbl.textContent = label(SIZES[1]);
    if ('IntersectionObserver' in root) { new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) play(); else stop(); }); }, { rootMargin: '80px' }).observe(box); } else play();
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else if (box.getBoundingClientRect().top < root.innerHeight) play(); });
  }

  /* ---------- UI ---------- */
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function icon(name, cls) { return '<svg class="abq__ico' + (cls ? ' ' + cls : '') + '" aria-hidden="true" focusable="false"><use href="#abq-i-' + name + '"></use></svg>'; }
  function track(step, answer, size) {
    try { root.dataLayer = root.dataLayer || []; root.dataLayer.push({ event: 'ab_quiz', quiz_step: step, quiz_answer: answer || '', quiz_size: size || '' }); } catch (e) { /* noop */ }
  }
  function headerOffset() {
    var h = document.querySelector('.header--sticky, .section-header, store-header, header.header, #header, .shopify-section-header'); var hh = h ? h.getBoundingClientRect().height : 0;
    if (!hh || hh > 260) hh = root.innerWidth < 768 ? 130 : 96; return hh + 12;
  }
  function scrollToEl(el) {
    if (!el) return; var top = el.getBoundingClientRect().top + root.pageYOffset - headerOffset();
    var reduce = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { root.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { root.scrollTo(0, top); }
  }
  function qs(name) { var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(root.location.search); return m ? decodeURIComponent(m[1]) : null; }

  function init(el) {
    if (el.__abq) return; el.__abq = true;
    var intro = el.querySelector('[data-abq-intro]'), panel = el.querySelector('[data-abq-panel]'), result = el.querySelector('[data-abq-result]');
    var startBtn = el.querySelector('[data-abq-start]'), startLabel = startBtn.querySelector('[data-abq-start-label]'), startIco = startBtn.querySelector('use');
    var startText = startLabel ? startLabel.textContent : '';
    var colUrl = el.getAttribute('data-collection-url') || '/collections/torby-papierowe';
    var printUrl = el.getAttribute('data-show-print') === 'true' ? (el.getAttribute('data-print-url') || '') : '';
    var samplesUrl = el.getAttribute('data-samples-url') || '';
    var resultsSection = el.getAttribute('data-results-section') || 'ab-quiz-results';
    var T = {}; try { T = JSON.parse(el.querySelector('[data-abq-i18n]').textContent); } catch (e) { T = {}; }
    function t(k, vars) { var str = T[k] || k; if (vars) Object.keys(vars).forEach(function (v) { str = str.split('{' + v + '}').join(vars[v]); }); return str; }
    function tl(ty) { return t('type_' + ty); }
    var ucs = []; try { ucs = JSON.parse(el.querySelector('[data-abq-usecases]').textContent); } catch (e) { ucs = []; }
    var QTY_OPTS = [{ id: 'one', icon: 'one' }, { id: 'few', icon: 'few' }, { id: 'many', icon: 'many' }].map(function (o) { o.label = t('qty_' + o.id); o.hint = t('qty_' + o.id + '_hint'); return o; });
    var TIER_OPTS = [{ id: 'eco', icon: 'eco' }, { id: 'uni', icon: 'uni' }, { id: 'prem', icon: 'prem' }, { id: 'any', icon: 'any' }].map(function (o) { o.label = t('tier_' + o.id); o.hint = t('tier_' + o.id + '_hint'); return o; });
    var sizes = null;
    try { sizes = JSON.parse(el.querySelector('[data-abq-sizes]').textContent); } catch (e) { sizes = null; }
    initBanner(el.querySelector('[data-abq-anim]'));
    var state = { step: 1, uc: null, qty: null, tier: null, reco: null, current: null, filter: { type: null, color: null }, open: false };

    function setStart(open) {
      if (startLabel) startLabel.textContent = open ? t('close') : startText;
      if (startIco) startIco.setAttribute('href', open ? '#abq-i-close' : '#abq-i-arrow');
      startBtn.setAttribute('aria-expanded', String(open));
    }
    function open(noScroll) {
      state.open = true; intro.classList.add('abq__intro--open'); setStart(true);
      panel.hidden = false; result.hidden = true; state.step = 1; renderStep(noScroll); track('start');
    }
    function close(focusStart) {
      state.open = false; panel.hidden = true; result.hidden = true; intro.classList.remove('abq__intro--open'); setStart(false);
      if (focusStart) startBtn.focus({ preventScroll: true });
      scrollToEl(el);
    }
    function optionTile(o, group) {
      return '<button type="button" class="abq__opt" data-abq-opt="' + esc(group) + '" data-id="' + esc(o.id) + '" aria-pressed="false">' +
        icon(o.icon || 'gift') + '<span class="abq__opt-text"><span class="abq__opt-label">' + esc(o.label) + '</span>' + (o.hint ? '<span class="abq__opt-hint">' + esc(o.hint) + '</span>' : '') + '</span></button>';
    }
    function stepsBar(step) {
      var labels = [t('s1'), t('s2'), t('s3')], html = '<ol class="abq__steps" aria-label="' + esc(t('step_of', { n: step })) + '">';
      for (var i = 1; i <= 3; i++) {
        var cls = i < step ? ' is-done' : i === step ? ' is-current' : '';
        html += '<li class="abq__step' + cls + '"' + (i === step ? ' aria-current="step"' : '') + '><span class="abq__step-n">' + (i < step ? icon('check') : i) + '</span><span class="abq__step-l">' + esc(labels[i - 1]) + '</span></li>';
      }
      return html + '</ol>';
    }
    function closeBtn(label) { return '<button type="button" class="abq__close" data-abq-close>' + esc(label || t('close')) + icon('close') + '</button>'; }
    function renderStep(noScroll) {
      var q, opts, group;
      if (state.step === 1) { q = t('q1'); opts = ucs; group = 'uc'; }
      else if (state.step === 2) { q = t('q2'); opts = QTY_OPTS; group = 'qty'; }
      else { q = t('q3'); opts = TIER_OPTS; group = 'tier'; }
      var chosen = state[group] ? (state[group].id || state[group]) : null;
      var html = '<div class="abq__top"><div class="abq__top-l">' + (state.step > 1 ? '<button type="button" class="abq__back" data-abq-back>' + icon('back') + esc(t('back')) + '</button>' : '') + stepsBar(state.step) + '</div>' + closeBtn() + '</div>';
      html += '<h3 class="abq__q" tabindex="-1">' + esc(q) + '</h3>';
      html += '<div class="abq__opts abq__opts--' + group + '">' + opts.map(function (o) { return optionTile(o, group); }).join('') + '</div>';
      panel.innerHTML = html;
      if (chosen) { var b = panel.querySelector('[data-id="' + chosen + '"]'); if (b) b.setAttribute('aria-pressed', 'true'); }
      var qEl = panel.querySelector('.abq__q'); if (qEl) qEl.focus({ preventScroll: true });
      if (!noScroll) scrollToEl(panel);
    }
    function pick(group, id) {
      if (group === 'uc') { state.uc = ucs.filter(function (u) { return u.id === id; })[0]; if (!state.uc) return; }
      else state[group] = id;
      track('q' + state.step, id);
      if (state.step < 3) { state.step++; renderStep(); return; }
      if (!sizes) { renderError(); return; }
      compute();
    }
    function compute() {
      state.reco = recommend(sizes, state.uc, state.qty, state.tier);
      state.current = state.reco.size; state.filter = { type: null, color: null };
      track('result', state.uc.id + '/' + state.qty + '/' + state.tier, state.current.key);
      renderResult();
    }
    function renderError() {
      panel.hidden = true; result.hidden = false;
      result.innerHTML = '<div class="abq__top"><span></span>' + closeBtn() + '</div><p class="abq__err">' + esc(t('err')) + ' <a href="' + esc(colUrl) + '">' + esc(t('err_link')) + '</a></p>';
    }
    function renderResult() {
      var r = state.reco, sz = state.current, uc = state.uc, params = filterParams(sz), isAlt = sz !== r.size;
      var fitTxt = uc.fits || uc.label;
      if (state.qty === 'few') fitTxt += ', ' + t('fits_few'); else if (state.qty === 'many') fitTxt += ', ' + t('fits_many');
      var reasons = [t('fits') + ' ' + fitTxt + '.'];
      var dt = dominantType(sz), paper = dt ? T['paper_' + dt] : null;
      reasons.push(t('in_size') + ' ' + typeList(sz, tl) + '.' + (paper ? ' ' + paper.charAt(0).toUpperCase() + paper.slice(1) + '.' : ''));
      if (r.tooBig && !isAlt) reasons.push(t('too_big'));
      else if (r.relaxed && !isAlt) reasons.push(t('relaxed', { types: typeList(sz, tl) }));
      var html = '<div class="abq__top"><p class="abq__reco-eyebrow">' + esc(isAlt ? t('reco_alt') : t('reco')) + '</p><span class="abq__top-r"><button type="button" class="abq__restart" data-abq-restart>' + icon('back') + esc(t('restart')) + '</button>' + closeBtn() + '</span></div>';
      html += '<div class="abq__reco"><div class="abq__art">' + bagStatic(sz) + '</div><div class="abq__reco-body">';
      html += '<h3 class="abq__reco-size" tabindex="-1">' + esc(dims(sz)) + '</h3>';
      html += '<p class="abq__dims">' + esc(t('dim_w')) + '\u00a0<b>' + sz.w + '</b> · ' + esc(t('dim_d')) + '\u00a0<b>' + sz.d + '</b> · ' + esc(t('dim_h')) + '\u00a0<b>' + sz.h + '</b>\u00a0mm</p>';
      html += '<ul class="abq__reasons">' + reasons.map(function (x) { return '<li>' + icon('check') + '<span>' + esc(x) + '</span></li>'; }).join('') + '</ul>';
      if (uc.note) html += '<p class="abq__note">' + (uc.note_url ? '<a href="' + esc(uc.note_url) + '">' + esc(uc.note) + '</a>' : esc(uc.note)) + '</p>';
      var switches = [];
      if (isAlt) switches.push('<button type="button" class="abq__chip abq__chip--switch" data-abq-size="' + esc(r.size.key) + '">' + icon('back') + esc(t('switch_back', { size: dims(r.size) })) + '</button>');
      else if (r.alt) switches.push('<button type="button" class="abq__chip abq__chip--switch" data-abq-size="' + esc(r.alt.key) + '">' + esc(t('switch_alt', { size: dims(r.alt) })) + '</button>');
      r.siblings.slice(0, 2).forEach(function (sb) { if (sb !== sz) switches.push('<button type="button" class="abq__chip abq__chip--switch" data-abq-size="' + esc(sb.key) + '">' + esc(t('similar', { size: dims(sb), types: typeList(sb, tl) })) + '</button>'); });
      if (switches.length) html += '<div class="abq__switches">' + switches.join('') + '</div>';
      html += '</div></div>';
      html += '<div class="abq__products"><div class="abq__products-head"><h4 class="abq__products-title">' + esc(t('products_title', { size: dims(sz) })) + '</h4><div class="abq__chips" data-abq-chips></div></div>';
      html += '<div class="abq__grid" data-abq-grid><p class="abq__loading">' + esc(t('loading')) + '</p></div></div>';
      html += '<div class="abq__ctas"><a class="abq-btn" href="' + esc(colUrl + '?' + params) + '">' + esc(t('cta_all')) + '</a>';
      if (samplesUrl) html += '<a class="abq-btn abq-btn--ghost" href="' + esc(samplesUrl) + '">' + esc(t('cta_samples')) + '</a>';
      if (printUrl) html += '<a class="abq-btn abq-btn--ghost" href="' + esc(sz.printDims ? printUrl + '?' + filterParams({ mfDims: [sz.printDims] }) : printUrl) + '">' + esc(t('cta_print')) + '</a>';
      html += '<span class="abq__ctas-right"><button type="button" class="abq__restart" data-abq-restart>' + icon('back') + esc(t('restart')) + '</button><button type="button" class="abq__restart" data-abq-close>' + esc(t('close_result')) + icon('close') + '</button></span></div>';
      panel.hidden = true; result.hidden = false; result.innerHTML = html;
      var h = result.querySelector('.abq__reco-size'); if (h) h.focus({ preventScroll: true });
      scrollToEl(result);
      loadGrid(params);
    }
    function loadGrid(params) {
      var grid = result.querySelector('[data-abq-grid]'), chips = result.querySelector('[data-abq-chips]');
      var url = colUrl + '?' + params + '&section_id=' + encodeURIComponent(resultsSection);
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        if (!grid.isConnected) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.abq-results');
        var items = inner ? inner.querySelectorAll('.abq-results__item') : [];
        if (!inner || !items.length) { grid.innerHTML = '<p class="abq__empty">' + esc(t('empty')) + ' <a href="' + esc(colUrl) + '">' + esc(t('empty_link')) + '</a></p>'; return; }
        grid.innerHTML = ''; grid.appendChild(inner);
        if (typeof root.initLazyImages === 'function') { try { root.initLazyImages(); } catch (e) { /* noop */ } }
        grid.querySelectorAll('img[data-src], img[data-srcset]').forEach(function (img) { if (img.dataset.src && !img.getAttribute('src')) img.src = img.dataset.src; if (img.dataset.srcset && !img.getAttribute('srcset')) img.srcset = img.dataset.srcset; });
        buildChips(chips, inner);
      }).catch(function () { grid.innerHTML = '<p class="abq__empty"><a href="' + esc(colUrl + '?' + params) + '">' + esc(t('cta_all')) + '</a></p>'; });
    }
    function buildChips(box, inner) {
      var types = {}, colors = {}, hex = {};
      inner.querySelectorAll('.abq-results__item').forEach(function (li) {
        var ty = li.getAttribute('data-type') || 'inne', c = li.getAttribute('data-color') || '', hx = li.getAttribute('data-hex') || '';
        types[ty] = (types[ty] || 0) + 1; if (c) { colors[c] = (colors[c] || 0) + 1; if (/^#[0-9a-f]{3,8}$/i.test(hx) && !hex[c]) hex[c] = hx; }
      });
      var html = '', tk = Object.keys(types), ck = Object.keys(colors).sort();
      var dot = function (c) { return hex[c] ? '<i class="abq__dot" style="background:' + esc(hex[c]) + '"></i>' : ''; };
      if (tk.length > 1) html += '<div class="abq__chip-group"><span class="abq__chip-lbl">' + esc(t('chip_type')) + '</span><div class="abq__chip-row">' + tk.map(function (ty) { return '<button type="button" class="abq__chip" data-abq-filter="type" data-val="' + esc(ty) + '" aria-pressed="false">' + esc(tl(ty)) + ' <b>' + types[ty] + '</b></button>'; }).join('') + '</div></div>';
      if (ck.length > 1) html += '<div class="abq__chip-group"><span class="abq__chip-lbl">' + esc(t('chip_color')) + '</span><div class="abq__chip-row">' + ck.map(function (c) { return '<button type="button" class="abq__chip" data-abq-filter="color" data-val="' + esc(c) + '" aria-pressed="false">' + dot(c) + esc(c) + ' <b>' + colors[c] + '</b></button>'; }).join('') + '</div></div>';
      box.innerHTML = html;
    }
    function applyFilter() {
      var inner = result.querySelector('.abq-results'); if (!inner) return;
      var f = state.filter, shown = 0;
      inner.querySelectorAll('.abq-results__item').forEach(function (li) {
        var ok = (!f.type || li.getAttribute('data-type') === f.type) && (!f.color || li.getAttribute('data-color') === f.color);
        li.hidden = !ok; if (ok) shown++;
      });
      result.querySelectorAll('[data-abq-filter]').forEach(function (b) { b.setAttribute('aria-pressed', String(f[b.getAttribute('data-abq-filter')] === b.getAttribute('data-val'))); });
      var empty = inner.querySelector('.abq-results__none');
      if (!shown) { if (!empty) { empty = document.createElement('p'); empty.className = 'abq-results__none abq__empty'; empty.textContent = t('none'); inner.appendChild(empty); } }
      else if (empty) empty.remove();
    }

    startBtn.addEventListener('click', function () { if (state.open) close(false); else open(); });
    el.addEventListener('click', function (e) {
      var tg = e.target.closest('[data-abq-opt], [data-abq-back], [data-abq-close], [data-abq-restart], [data-abq-size], [data-abq-filter]');
      if (!tg) return;
      if (tg.hasAttribute('data-abq-opt')) { pick(tg.getAttribute('data-abq-opt'), tg.getAttribute('data-id')); return; }
      if (tg.hasAttribute('data-abq-back')) { state.step = Math.max(1, state.step - 1); renderStep(); return; }
      if (tg.hasAttribute('data-abq-close')) { close(true); return; }
      if (tg.hasAttribute('data-abq-restart')) { state.uc = null; state.qty = null; state.tier = null; open(); return; }
      if (tg.hasAttribute('data-abq-size')) { var key = tg.getAttribute('data-abq-size'); var sz = (sizes || []).filter(function (x) { return x.key === key; })[0]; if (sz) { state.current = sz; state.filter = { type: null, color: null }; track('switch', key, key); renderResult(); } return; }
      if (tg.hasAttribute('data-abq-filter')) { var g = tg.getAttribute('data-abq-filter'), v = tg.getAttribute('data-val'); state.filter[g] = state.filter[g] === v ? null : v; applyFilter(); }
    });
    var auto = qs('abq');
    if (auto) { var a = auto.split(','); open(true); if (a[0]) pick('uc', a[0]); if (a[1]) pick('qty', a[1]); if (a[2]) pick('tier', a[2]); }
    else if (el.getAttribute('data-open') === 'true' || root.location.hash === '#dobierz-rozmiar') open();
  }
  function boot() { document.querySelectorAll('[data-abq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})(typeof window !== 'undefined' ? window : globalThis);
